import React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Unstable_Grid2';
import ListSubheader from '@mui/material/ListSubheader';
import Button from '@mui/material/Button';



const About: React.FC = () => {
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#151A1F',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'left',
    color: '#f2f4f6',
    overflow: 'auto',
    maxHeight:'52rem',
    height: 'fit-content', 
    position: 'fixed',
    width: '15vw', 
    marginLeft: '0px',
  }));
  
  return (

        <Box sx={{ width: '100%',}}>
          <Grid container spacing={1}>
            <Grid xs={2}>
              <Item>
                  <List 
                  subheader={
                    <ListSubheader component="div" id="nested-list-subheader" sx={{ width: '100%', margin: 'auto', color: '#ffff', bgcolor: '#2A343D', fontWeight: 'bold', fontSize: 16, textAlign: 'center'}}>
                      Contents
                    </ListSubheader>
                  }
                  >
                    <Divider />
                    <ListItem>
                      <ListItemButton href='#overview'>
                        <ListItemText primary="Overview" />
                      </ListItemButton>
                    </ListItem>
                    <Divider />
                    <ListItem>
                      <ListItemButton href='#island'>
                        <ListItemText primary="The Island" />
                      </ListItemButton>
                    </ListItem>
                    <Divider />
                    <ListItem>
                      <ListItemButton href="#altair">
                        <ListItemText primary="Altair" />
                      </ListItemButton>
                    </ListItem>
                    <Divider />
                    <ListItem>
                      <ListItemButton href="#lvtn">
                        <ListItemText primary="Leviathan ($LVTN)" />
                      </ListItemButton>
                    </ListItem>
                    <Divider />
                    <ListItem>
                      <ListItemButton href="#dao">
                        <ListItemText primary="Hyperborea DAO" />
                      </ListItemButton>
                    </ListItem>
                    <Divider />
                    
                  </List>
              </Item>
            </Grid>
            <Grid xs={10} sx={{paddingLeft: 6, paddingRight: 18}}>
              <h1 id='overview'>Welcome</h1>
              <p style={{marginBottom: '3rem', fontSize: 16}}>
                Welcome to Hyperborea, the paradise of the north. Located  at 54 degrees north and 35 degrees west, this is an island state run
                by the owners of the Hyperborea NFT collection. With infinite possibilities, where will you take this place? 
              </p>
              <Divider sx={{marginBottom: '5rem'}}/>

              <h1 id='island'>The Island</h1>
              <p style={{fontSize: 16}}>
                The island of Hyperborea is currently a blank canvas, and it will be built collaboratively by the people
                of this community using the Hyperborea DAO. 
              </p>
              <Box
                component="img"
                sx={{
                  alignContent: 'left',
                  marginBottom: '3rem'
                }}
                alt="Map of the island"
                src="https://i.imgur.com/gZmYGR4.png"
              />
              <Divider sx={{marginBottom: '5rem'}}/>

              <h1 id='altair'>Altair</h1>
              <p style={{fontSize: 16}}>  
                A small seaside suburb of the northwestern city Somergard, Altair is the perfect locale to begin your adventure on Hyperborea. The suburb has just had a land release of 10000 plots. Whether
                your home is along the dreamlike sands of the beach or atop the rolling hills overlooking the town, you are guaranteed to find 
                your own corner of paradise! Hit construct to be allocated a random plot of land with a randomly constructed house.    
              </p>
              <Box
                component="img"
                sx={{
                  alignContent: 'left',
                  marginBottom: '3rem'
                }}
                alt="Map of Altair"
                src="https://i.imgur.com/FOmSckX.png"
              />
              <Divider sx={{marginBottom: '5rem'}}/>

              <h1 id='lvtn'>Leviathan ($LVTN)</h1>
              <Box
                component="img"
                sx={{
                  alignContent: 'left',
                  maxHeight: '64px', 
                  maxWidth: '64px', 
                }}
                alt="LVTN Logo"
                src="https://i.imgur.com/oaKIVBo.png"
              />
              <p style={{marginBottom: '3rem', fontSize: 16}}>
                Leviathan (LVTN) is an SPL token and the currency of Hyperborea. This currency will be used for all commerce involving the island, and will 
                also be used to run the DAO. NFT holders can earn LVTN through passive income (airdrops) and spend it at the store.
                Each property type earns a different amount of passive income, through rent that is paid once every week on Sunday, 0000 UTC. 
                All holders will receive the following amounts of LVTN based on the property type:
                <ul>
                  <li>Colonial - 1.2</li>
                  <li>Single Family Home (SFH) - 1</li>
                  <li>Contemporary - 0.8</li>
                  <li>French Provincial (FP) - 1.5</li>
                  <li>Apartments - 2.5</li>
                  <li>Store - 2</li>
                  <li>Shack - 0.5</li>
                </ul>
                This amount of LVTN will be airdropped into wallets containing Hyperborea: Altair NFTs once per week. 
              </p>
              <Divider sx={{marginBottom: '5rem'}}/>

              <h1 id='dao'>Hyperborea DAO</h1>
              <p style={{fontSize: 18}}>Access the <Button variant="contained" color='success' href='https://app.realms.today/dao/CAhWURtUHVgUwXRxSQdrkuBTxPuzQ4g39uQMovX1ZLAi'>DAO HERE</Button></p>
              <p style={{fontSize: 16}}>
                The Decentralized Autonomous Organization (DAO) will be the primary decision making body for this NFT project. 
                The DAO is run using LVTN, allowing members to make and vote on proposals based on the amount of LVTN they own. 
                This DAO will decide the direction of the Hyperborea Project, letting the community work together to build
                the island and take it to new heights. 

                The DAO will earn 0.1% of the secondary sales from the NFTs, allowing it to build up SOL over time. It will
                also receive 5% of the initial minting sales. This gives the DAO purchasing power and will help fund the future 
                of the project.
              </p>
              <Divider sx={{marginBottom: '5rem'}}/>

            </Grid>
          </Grid>
          </Box>
  
   
  )
}

export default About